import { Machine, assign, sendParent } from "xstate"
import * as luckydrawBusiness from "../../business/luckydraw"
export const createLuckLotteryMachine = ({ groupid, codeId, context }) => {
  return Machine(
    {
      id: "lottery",
      context: {
        ...context,
        groupid,
        codeId,
        award: ""
      },
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "luck_lottery",
            src: "startDraw",
            onDone: {
              target: "success",
              actions: ["setAward"]
            },
            onError: {
              target: "failure",
              actions: ["sendError"]
            }
          }
        },
        success: {
          entry: ["sendSuccess"]
          // on: {
          //   DRAW: {
          //     actions: ["setCodeId"],
          //     target: "pending"
          //   }
          // }
        },
        failure: {
          on: {
            RETRY: "pending"
          }
        }
      },
      on: {
        DRAW: {
          actions: ["setCodeId"],
          target: "pending"
        }
      }
    },
    {
      services: {
        startDraw: context => {
          return luckydrawBusiness.startDraw({
            sandbox: context.sandbox,
            loginState: context.loginState,
            offerId: context.gameConfig.offerId,
            groupid: context.groupid,
            game_platform_id: context.partitionInfo.game_platform_id,
            gameid: `${context.partitionInfo.area}___${context.partitionInfo.partition}`,
            code_id: context.codeId
          })
        }
      },
      actions: {
        setCodeId: (context, event) => {
          context.codeId = event.codeId
        },
        setAward: assign({
          award: (context, event) => event.data
        }),
        sendError: sendParent((context, event) => ({
          type: "DRAW_ERROR",
          data: event.data
        })),
        sendSuccess: sendParent((context, event) => ({
          type: "DRAW_SUCCESS",
          data: event.data
        }))
      }
    }
  )
}
